import { string as sanitizeString } from 'olapic-js-utils/browser/sanitize';

const routeProviderConfig = ($routeProvider) => {
  'ngInject';

  $routeProvider
  .when('/users/:id/activities', {
    template: ({ id = '' }) => `
      <users-container
        selected-id="${sanitizeString(id)}"
        sub-section="activities"
      ></users-container>
    `,
    requiresPermissions: [['admin', 'super_admin', 'brand_admin']],
  })
  .when('/users/:id?', {
    template: ({ id = '' }) => `
      <users-container selected-id="${sanitizeString(id)}"></users-container>
    `,
  })
  .otherwise({ redirectTo: '/users' });
};

export default routeProviderConfig;
